'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.withService = exports.withSaga = void 0;
var tslib_1 = require('tslib');
var react_1 = (0, tslib_1.__importStar)(require('react'));
var useSaga_1 = require('./hooks/useSaga');
var Operation_1 = require('./components/Operation');
var useDI_1 = require('./hooks/useDI');
var useService_1 = require('./hooks/useService');
var hooks_1 = require('./hooks');
function withSaga(_a) {
    var sagaFactory = _a.sagaFactory,
        _b = _a.argsMapper,
        argsMapper =
            _b === void 0
                ? function () {
                      return [];
                  }
                : _b,
        options = _a.options;
    return function (Component) {
        return function SagaBind(props) {
            var fallback = props.fallback,
                rest = (0, tslib_1.__rest)(props, ['fallback']);
            var diContext = (0, useDI_1.useDI)();
            var operationId = (0, useSaga_1.useSaga)(sagaFactory(diContext), argsMapper(props), options).operationId;
            return react_1.default.createElement(
                react_1.Suspense,
                { fallback: fallback || null },
                react_1.default.createElement(
                    Operation_1.Operation,
                    { operationId: operationId },
                    function (operation) {
                        return react_1.default.createElement(
                            Component,
                            (0, tslib_1.__assign)({}, rest, { operation: operation })
                        );
                    }
                )
            );
        };
    };
}
exports.withSaga = withSaga;
function withService(_a) {
    var serviceFactory = _a.serviceFactory,
        _b = _a.argsMapper,
        argsMapper =
            _b === void 0
                ? function () {
                      return [];
                  }
                : _b,
        options = _a.options;
    return function (Component) {
        return function SagaBind(props) {
            var fallback = props.fallback,
                rest = (0, tslib_1.__rest)(props, ['fallback']);
            var diContext = (0, useDI_1.useDI)();
            var service = (0, react_1.useMemo)(
                function () {
                    return serviceFactory(diContext);
                },
                [diContext]
            );
            diContext.registerService(service);
            var operationId = (0, useService_1.useService)(service, argsMapper(props), options).operationId;
            var actions = (0, hooks_1.useServiceConsumer)(service.constructor).actions;
            return react_1.default.createElement(
                react_1.Suspense,
                { fallback: fallback || null },
                react_1.default.createElement(
                    Operation_1.Operation,
                    { operationId: operationId },
                    function (operation) {
                        return react_1.default.createElement(
                            Component,
                            (0, tslib_1.__assign)({}, rest, {
                                operation: operation,
                                actions: actions,
                                service: service,
                            })
                        );
                    }
                )
            );
        };
    };
}
exports.withService = withService;
